import { i18n } from "../../../boot/i18n.js";

import report from "./report.js";
import goals from "./goals.js";
import games from "./games.js";
import commission from "./commission.js";
import leadTimes from "./lead-times.js";
import callLog from "./call-log.js";
import mileageLog from "./mileage-log.js";

const children = [
  ...report.routes,
  ...goals.routes,
  ...games.routes,
  ...commission.routes,
  ...leadTimes.routes,
  ...callLog.routes,
  ...mileageLog.routes,
];

export default {
  routes: [
    {
      name: "sales-tools",
      path: "sales-tools",
      component: () => import("pages/sales-tools/Index"),
      meta: {
        auth: () =>
          children.some((route) => route.meta.auth && route.meta.auth()),
        icon: "sales_tools",
        title: i18n.global.t("Sales Tools"),
        color: "primary",
      },
      children,
    },
  ],

  dialogs: [
    ...report.dialogs,
    ...goals.dialogs,
    ...games.dialogs,
    ...commission.dialogs,
    ...callLog.dialogs,
    ...mileageLog.dialogs,
    ...leadTimes.dialogs,
  ],
};
